import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { AuctionLayoutComponent } from "./layouts/auction/auction-layout.component";
const routes: Routes = [
  {
    path: "",
    component: AuctionLayoutComponent,
    children: [
      {
        path: "",
        loadChildren: () =>
          import("./modules/home/home.module").then(
            (module) => module.HomeModule,
          ),
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
